import script from "./SwitchFontSize.vue?vue&type=script&setup=true&lang=js"
export * from "./SwitchFontSize.vue?vue&type=script&setup=true&lang=js"

import "./SwitchFontSize.vue?vue&type=style&index=0&id=5d721b3b&scoped=true&lang=less"
import "./SwitchFontSize.vue?vue&type=style&index=1&id=5d721b3b&lang=less"

import exportComponent from "../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d721b3b"]])

export default __exports__